import * as T from './loyaltyAutomatedRewardsTypes';
import type { Reward } from '../../../components/loyalty/data/types';

export const fetchAutomatedRewardsRequest = () => ({
  type: T.FETCH_AUTOMATED_REWARDS_REQUEST as typeof T.FETCH_AUTOMATED_REWARDS_REQUEST,
});
export const fetchAutomatedRewardsSuccess = (rewards: Reward[]) => ({
  type: T.FETCH_AUTOMATED_REWARDS_SUCCESS as typeof T.FETCH_AUTOMATED_REWARDS_SUCCESS,
  payload: rewards,
});
export const fetchAutomatedRewardsFailure = (error: string) => ({
  type: T.FETCH_AUTOMATED_REWARDS_FAILURE as typeof T.FETCH_AUTOMATED_REWARDS_FAILURE,
  payload: error,
});

export const clearAutomatedRewardsError = () => ({
  type: T.CLEAR_AUTOMATED_REWARDS_ERROR as typeof T.CLEAR_AUTOMATED_REWARDS_ERROR,
});

export type LoyaltyAutomatedRewardsAction =
  | ReturnType<typeof fetchAutomatedRewardsRequest>
  | ReturnType<typeof fetchAutomatedRewardsSuccess>
  | ReturnType<typeof fetchAutomatedRewardsFailure>
  | ReturnType<typeof clearAutomatedRewardsError>;
